export function getInitials(name: string) {
  name = (name || '').trim();
  if (!name) {
    return '';
  }

  let s = name[0].toUpperCase();
  let i = name.indexOf(' ', 1);
  while (i !== -1) {
    const next = name[i + 1];
    if (!next) {
      break;
    }

    if (next === ' ') {
      i++;
    } else {
      s += next.toUpperCase();
      i = name.indexOf(' ', i + 1);
    }
  }

  return s;
}

export function getFullName({
  firstname,
  lastname,
  preferredname,
  fullname,
}: {
  firstname?: string;
  lastname?: string;
  preferredname?: string;
  fullname?: string;
}) {
  lastname = lastname ? lastname.trim() : '';
  fullname = fullname ? fullname.trim() : '';
  let s = (preferredname || firstname || '').trim();
  let count = s ? 1 : 0;
  if (lastname) {
    s += (s ? ' ' : '') + lastname;
    count++;
  }

  if ((!s || count < 2) && fullname) {
    s = fullname;
  }

  return s;
}

export function getLastName({
  lastname,
  fullname,
}: {
  lastname?: string;
  fullname?: string;
}) {
  if (lastname) {
    lastname = lastname.trim();
  }

  if (lastname) {
    return lastname;
  }

  if (fullname) {
    fullname = fullname.trim();
  }

  if (!fullname) {
    return '';
  }

  const index = fullname.lastIndexOf(' ');
  if (index === -1) {
    return '';
  }

  return fullname.substring(index + 1);
}

export function getFirstName({
  firstname,
  fullname,
}: {
  firstname?: string;
  fullname?: string;
}) {
  if (firstname) {
    firstname = firstname.trim();
  }

  if (firstname) {
    return firstname;
  }

  if (fullname) {
    fullname = fullname.trim();
  }

  if (!fullname) {
    return '';
  }

  const index = fullname.indexOf(' ');
  if (index === -1) {
    return fullname;
  }

  return fullname.substring(0, index);
}
